import { camelCase, pascalCase } from 'change-case';
export const rolesDivider = ', ';
export const formatScopeName = (scopeName) => pascalCase(scopeName);
export const formatViewName = (viewName) => pascalCase(viewName);
export const formatViewType = (viewType) => (viewType === 'dataGrid' ? 'List' : pascalCase(viewType));
export const getViewName = ({ entityName, viewType }) => formatViewName(entityName) + formatViewType(viewType);
export const getScopeName = ({ entityName, suffix }) => formatScopeName(entityName) + (suffix ? pascalCase(suffix) : '');
export const getFormName = (entityName) => pascalCase(entityName) + 'Form';
export const getReadoutName = (entityName) => pascalCase(entityName) + 'Readout';
export const getRoleNames = (...roles) => roles.map(it => camelCase(it)).join(rolesDivider);
export const getPreviewName = (entityName) => pascalCase(entityName) + 'Preview';
const isScopeType = (value) => {
    return ['dataGrid', 'update', 'create', 'detail', 'edit', 'multiEdit', 'plugin', 'unique'].includes(value);
};
export const getScopeType = (value) => {
    const scopeType = camelCase(value);
    if (isScopeType(scopeType)) {
        switch (scopeType) {
            case 'update':
                return 'edit';
            default:
                return scopeType;
        }
    }
    return undefined;
};
//# sourceMappingURL=nameFormat.js.map